<template>
    <div class="tab-container">
        <!-- <div class="max-container--zero">
            <div class="export-bar__buttons" :class="{ inactive: !loggedIn }">
                <span class="d-none d-md-inline export-text font-arial">Export view:</span>
                <button @click="exportFilteredExcel" class="export-bar__button font-arial disabled" :class="{ running: excelRunning }" :disabled="true">
                    <div class="icon icon--export"></div>
                    <span>Export Excel</span>
                </button>
                <button @click="exportFilteredPdf" class="export-bar__button font-arial" :class="{ disabled: compareOpen, running: pdfRunning }" :disabled="compareOpen">
                    <div class="icon icon--export"></div>
                    <span>Export PDF</span>
                </button>
            </div>
        </div> -->
        <transition-group tag="div" class="tabs" name="tab">
            <media-container key="media" v-if="currentTab === 'media'"></media-container>
            <website-container key="website" v-if="currentTab === 'website'"></website-container>
        </transition-group>
    </div>
</template>

<script>
    import store from '@/store';
    import pageExport from '@/util/pageExport';

    import MediaContainer from '@/components/MediaContainer';
    import WebsiteContainer from '@/components/WebsiteContainer';

    export default {
        components: {
            MediaContainer,
            WebsiteContainer,
        },
        data() {
            return {
                excelRunning: false,
                pdfRunning: false,
            };
        },
        computed: {
            currentTab() {
                return store.state.currentTab;
            },
            compareOpen() {
                return store.state.compareChartOpen[store.state.currentTab];
            },
            loggedIn() {
                return store.state.loggedIn;
            },
        },
        methods: {
            exportFilteredPdf() {
                this.pdfRunning = true;
                pageExport.export(this, {
                    format: 'pdf',
                    type: 'filtered',
                }).then(() => {
                    this.pdfRunning = false;
                });
            },
            exportFilteredExcel() {
                this.excelRunning = true;
                pageExport.export(this, {
                    format: 'excel',
                    type: 'filtered',
                }).then(() => {
                    this.excelRunning = false;
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .tab-container {
        padding-top: 20px; // whilst export buttons are hidden
    }

    .export-bar {
        &__buttons {
            display: flex;
            justify-content: space-between;
            align-items: center;

            bottom: 0;
            right: 0;

            width: 100%;

            margin-bottom: 20px;

            @media screen and (min-width: $tablet) {
                justify-content: flex-end;
                margin-bottom: 30px;
            }

            &.inactive {
                display: none;
            }

            .export-text {
                margin-right: 8px;
                font-size: 12px;
                line-height: 1.1;
            }
        }

        &__button {
            flex-basis: 49.8%;

            padding: 12px 0 11px 10px;

            background-color: $kpmg-blue;

            color: white;
            font-size: 12px;
            letter-spacing: 0.6px;

            cursor: pointer;

            .icon,
            span {
                transition: opacity 0.5s ease;
            }

            @media screen and (min-width: $tablet) {
                flex-basis: auto;
                margin-left: 3px;
                padding: 11px 10px 10px 10px;
            }

            &.running {
                animation-name: running;
                animation-duration: 2s;
                animation-timing-function: ease;
                animation-iteration-count: infinite;
            }

            &.disabled {
                cursor: default;

                .icon,
                span {
                    opacity: 0.3;

                }
            }

            .icon {
                display: inline-block;
                vertical-align: middle;
            }

            span {
                vertical-align: middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TabContainer.vue